import React, { useState } from 'react';
import CreatePlan from './createPlan';
import ViewPlan from './viewPlan';
import { useUserLevel, AdminLevel } from '../../context/admin';

// ─── Types ────────────────────────────────────────────────────────────────────

type OptionKey = 'create' | 'view';

interface MenuOption {
  key: OptionKey;
  label: string;
}

// ─── Modal map ────────────────────────────────────────────────────────────────

const renderModal = (key: OptionKey, onClose: () => void): React.ReactNode => {
  switch (key) {
    case 'create': return <CreatePlan onClose={onClose} />;
    case 'view':   return <ViewPlan onClose={onClose} />;
    default:       return null;
  }
};

// ─── Per-role menu options ────────────────────────────────────────────────────

const getMenuOptions = (level: AdminLevel): MenuOption[] => {
  switch (level) {
    case AdminLevel.SUPER_ADMIN:
      return [
        { key: 'create', label: 'Create Plan' },
        { key: 'view',   label: 'View Plans'  },
      ];
    default:
      return [];
  }
};

// ─── Component ────────────────────────────────────────────────────────────────

const Plan: React.FC = () => {
  const { currentUserLevel } = useUserLevel();
  const [selectedOption, setSelectedOption] = useState<OptionKey | null>(null);

  const menuOptions = getMenuOptions(currentUserLevel);

  if (menuOptions.length === 0) return null;

  return (
    <>
      <div className="dropdown">
        <label tabIndex={0} className="btn mx-2 btn-inactive">Recovery Plans</label>
        <ul
          tabIndex={0}
          className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 z-50"
        >
          {menuOptions.map(opt => (
            <li key={opt.key} onClick={() => setSelectedOption(opt.key)}>
              <a>{opt.label}</a>
            </li>
          ))}
        </ul>
      </div>

      {selectedOption && renderModal(selectedOption, () => setSelectedOption(null))}
    </>
  );
};

export default Plan;